import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import LinkWithIconComponent from '../LinkWithIcon/LinkWithIconComponent';
import Image from '../../Image/Image';

const ThreeCardCarGuideComponent = ({ data }) => {
  const { title, description, buttonText, buttonLink, guides = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '1216px',
          borderRadius: '48px',
          boxSizing: 'border-box',
          textAlign: 'center',
        }}
      >
        {/* Header */}
        <ScrollFadeWrapper variant="text">
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '3rem',
              lineHeight: '3.25rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              mb: '16px',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        {/* Description */}
        <ScrollFadeWrapper variant="text" delay={0.2}>
          <Typography
            component="p"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '1.75rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              mb: '40px',
              maxWidth: '980px',
              mx: 'auto',
            }}
          >
            {description}
          </Typography>
        </ScrollFadeWrapper>

        {/* Cards */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch',
            gap: '24px',
            mb: '40px',
          }}
        >
          {guides.map((guide, index) => (
            <ScrollFadeWrapper key={index} delay={index * 0.15}>
              <Box
                sx={{
                  flex: '1 1 0',
                  width: '100%',
                  maxWidth: '560px',
                  height: '100%',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '34px',
                  boxShadow:
                    '0px 6px 16px 0px #162F3B1F, 0px 1px 2px 0px #A2ACB11F',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                }}
              >
                {/* Image */}
                <Image
                  width={390}
                  height={219}
                  src={guide.image}
                  alt={guide.imgAltTag}
                  title={guide.imageAltTitle}
                  sx={{
                    width: '100%',
                    height: '219px',
                    objectFit: 'cover',
                    backgroundColor: '#A2ACB1',
                  }}
                />

                {/* Content */}
                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    pt: '40px',
                    pb: '40px',
                  }}
                >
                  <Box sx={{ px: '40px' }}>
                    {/* Title */}
                    <Typography
                      component="h6"
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        fontSize: '1.25rem',
                        lineHeight: '1.5rem',
                        letterSpacing: '-0.03em',
                        color: '#162F3B',
                        mb: '16px',
                        textAlign: 'left',
                      }}
                    >
                      {guide.title}
                    </Typography>

                    {/* Body */}
                    <Typography
                      component="p"
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 400,
                        fontSize: '0.875rem',
                        lineHeight: '1.25rem',
                        letterSpacing: '-0.02em',
                        color: '#162F3B',
                        textAlign: 'left',
                      }}
                    >
                      {guide.body}
                    </Typography>
                  </Box>

                  {/* Link */}
                  <Box sx={{ textAlign: 'right', px: '40px', mt: '24px' }}>
                    <Link
                      component="a"
                      href={guide.redirect}
                      underline="none"
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        fontSize: '1rem',
                        lineHeight: '1.5rem',
                        letterSpacing: '-0.02em',
                        color: '#162F3B',
                        '&:hover': {
                          color: '#9EA900',
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      Read More
                    </Link>
                  </Box>
                </Box>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>

        {/* Footer */}
        {buttonText && buttonLink && (
          <LinkWithIconComponent
            href={buttonLink}
            iconSize="1rem"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '1.5rem',
              letterSpacing: '-0.02em',
              color: '#162F3B',
              textAlign: 'center',
              '&:hover': { color: '#9EA900' },
            }}
          >
            {buttonText}
          </LinkWithIconComponent>
        )}
      </Box>
    </Box>
  );
};

export default ThreeCardCarGuideComponent;
